import { combineReducers, Reducer } from 'redux'
import { connectRouter } from 'connected-react-router'
import { BrowserHistory } from 'history'
import { reducer as dataReducer } from '../utils/data-reducer/reducer'
import { reducer as countriesReducer } from '../containers/navbar/reducer'
import {
  reducer as landingPagesReducer,
  themeReducer,
} from '../containers/home/reducer'
import { reducer as requestsReducer } from '../utils/requests-reducer/reducer'

export const createReducer = (history: BrowserHistory): Reducer =>
  combineReducers({
    router: connectRouter(history),
    countries: countriesReducer,
    landingPages: landingPagesReducer,
    themes: themeReducer,
    data: dataReducer,
    requests: requestsReducer,
  })
